import styled from 'styled-components';

export const Card = styled.div`
  position: relative;
  width: 100%;
`

export const CardBody = styled.div`
  border: 1px solid #F1F4F5;
  box-shadow: 0px 5px 15px rgba(232, 236, 238, 0.43);
  border-radius: 14px;
  padding: ${props => props.padding || 0}
`;

export const CardTitle = styled.div`
  color: #5C6368;
  font-weight: 500;
  font-size: 13px;
  line-height: 15px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: ${props => props.mb || 15}px;
`;

export const CardBodyHead = styled.div`
  height: 80px;
  border-bottom: 1px solid #F1F4F5;
  display: flex;
  padding: 0 15px;
  align-items: center;
  justify-content: space-between;
`;

export const CardBodyFoot = styled.div`
  height: 65px;
  padding: 15px 15px 0;
`;

export const BoldTitle = styled.h3`
  margin: 0;
  font-size: 28px;
  line-height: 33px;
  font-weight: 500;
  margin-bottom: ${props => props.mb || 0}px;
  color: ${props => props.color || 'inherit'}
`

export const Icon = styled.div`
  background: #CCEFF1;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`


export default {
  Card,
  CardBody,
  CardTitle,
  CardBodyHead,
  CardBodyFoot,
  Icon,
  BoldTitle
}
